var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',[_c('v-tab',[_vm._v("Bookmarks")]),_c('v-tab',[_vm._v("RSS")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }